import React, { useEffect, useState } from "react";
import {
  Heading2,
  Body2,
} from "../../../components/value-cssmodules/TextComponent";
import { FormattedMessage } from "react-intl";
import LightButton from "../../../components/Button/LightButton";
import styles from "./StartSell.module.scss";
import { Link } from "react-router";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { OPEN_MODAL_POPUP, PopupInner } from "../../../types/siteTypes";

const StartSell = () => {
  const user = useSelector((state: any) => state.auth.user);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const dispatch = useDispatch();


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      className={styles.startSell}
      style={{
        backgroundImage: "url('/photos/start-selling.png')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: isMobile ? "center bottom" : "",
        backgroundSize: isMobile ? "202%" : "",
      }}
    >
      <header className={styles.titleSell}>
        <Heading2>
          <FormattedMessage
            id={"nav.headingStartSell"}
            defaultMessage={"Start selling your patterns!"}
          />
        </Heading2>
        <Body2 className={styles.body2}>
          <FormattedMessage
            id={"nav.bodyStartSell"}
            defaultMessage={
              "Register and start making more on your patterns how much do you want. Set a price, we will take care of the rest :D"
            }
          />
        </Body2>
      </header>
      <Link to={user ? "manage-pattern" : "/register"}>
        <LightButton>
          <FormattedMessage
            id={"nav.startSellingPatterns"}
            defaultMessage={"Start selling patterns"}
          />
        </LightButton>
      </Link>
      <span className={styles.loginLink}>
        { !user && (
          <>
          <FormattedMessage
            id={"nav.alreadyHaveAccount"}
            defaultMessage={"Already have an account?"}
          />{" "}
        
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            dispatch({
              type: OPEN_MODAL_POPUP,
              payload: PopupInner.LogIn,
            });
          }}
        >
          <FormattedMessage 
          id={"site.login"}
          defaultMessage={"Login"} />
        </Link>
          </>
    )}
      </span>
    </section>
  );
};

export default StartSell;
